import { useLayoutEffect, useState } from 'react';

/**
 * True when the browser reports touch-first, no-hover primary input (typical phones).
 * Framer Motion drag is flaky here; use tap / explicit pointer placement instead.
 */
export function useTouchFirstPlacement() {
  const [touchFirst, setTouchFirst] = useState(() =>
    typeof window !== 'undefined' && window.matchMedia?.('(hover: none) and (pointer: coarse)').matches,
  );

  useLayoutEffect(() => {
    const mq = window.matchMedia('(hover: none) and (pointer: coarse)');
    const sync = () => setTouchFirst(mq.matches);
    sync();
    mq.addEventListener('change', sync);
    return () => mq.removeEventListener('change', sync);
  }, []);

  return touchFirst;
}
